/* eslint-disable */
import { useContext, useEffect, useLayoutEffect } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import { useHasPermission, PERMISSIONS } from '../../utils/permissions';
import { useNotifications } from '../../context/NotificationContext';
import GoogleTranslateManager from './GoogleTranslateManager';
import {
    FiPieChart,
    FiUsers,
    FiTruck,
    FiBell,
    FiSearch,
    FiSettings,
    FiLogOut,
    FiShoppingCart,
    FiPackage,
    FiLayout,
    FiBarChart
} from 'react-icons/fi';
import { FaCaretRight } from 'react-icons/fa';
import { SiProgress } from 'react-icons/si';


const Header = () => {
    const { loggedUser } = useContext(AuthContext);
    const location = useLocation();
    const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();

    useEffect(() => {
        // Replace feather icons on mount
        if (window.feather) {
            window.feather.replace();
        }
    }, []);

    const handleNavbarVerticalToggle = (e) => {
        // Fallback toggle mechanism in case phoenix.js listener isn't attached
        const { getItemFromStore, setItemToStore } = window.phoenix?.utils || {
            getItemFromStore: (key, def) => {
                const item = localStorage.getItem(key);
                try {
                    return item ? JSON.parse(item) : def;
                } catch {
                    return item || def;
                }
            },
            setItemToStore: (key, val) => localStorage.setItem(key, JSON.stringify(val))
        };

        const isCollapsed = document.documentElement.classList.contains('navbar-vertical-collapsed');
        document.documentElement.classList.toggle('navbar-vertical-collapsed');
        setItemToStore('phoenixIsNavbarVerticalCollapsed', !isCollapsed);

        // Dispatch the custom event that phoenix.js and other components (like ECharts) expect
        const toggleEvent = new CustomEvent('navbar.vertical.toggle');
        document.dispatchEvent(toggleEvent);
        
        // Also dispatch to the element itself to trigger phoenix.js listeners if any
        if (e.currentTarget) {
            e.currentTarget.dispatchEvent(new CustomEvent('navbar.vertical.toggle'));
        }
    };

    // Add useLayoutEffect to handle feather icon replacement on route changes
    useLayoutEffect(() => {
        // Small delay to ensure DOM is updated
        setTimeout(() => {
            if (window.feather) {
                window.feather.replace();
            }
        }, 50);
    }, [location.pathname]);

    // Define a centralized list of CSS selectors for elements that should not be translated.
    // You can add selectors for elements from any component here.
    const noTranslateSelectors = [
        '.logo-text',
        '.notification-title',
        '.notification-message',
        '.notification-time',
        '#profile-user-name',
        '.app-version',
        'nav',
        'footer',
        'button',
        'table-responsive td'
    ];

    // Permission hooks
    const canViewProducts = useHasPermission(PERMISSIONS.VIEW_PRODUCTS);
    const canViewWarehouses = useHasPermission(PERMISSIONS.WAREHOUSE_VIEW);
    const canViewPackagingMaterial = useHasPermission(PERMISSIONS.PACKAGING_MATERIAL_VIEW);

    const canViewBrokers = useHasPermission(PERMISSIONS.VIEW_BROKERS);
    const canViewVendors = useHasPermission(PERMISSIONS.VIEW_VENDORS);
    const canViewBuyers = useHasPermission(PERMISSIONS.VIEW_BUYERS);
    const canManageStaff = useHasPermission([PERMISSIONS.ADD_STAFF, PERMISSIONS.EDIT_STAFF]);
    const canManageUsers = useHasPermission(PERMISSIONS.USER_MANAGEMENT);

    const canViewPurchaseRequests = useHasPermission(PERMISSIONS.PO_REQUEST_VIEW);
    const canViewPurchaseOrders = useHasPermission(PERMISSIONS.PO_VIEW);

    const canViewBOM = useHasPermission(PERMISSIONS.BOM_VIEW);
    const canViewProductionRequests = useHasPermission(PERMISSIONS.PRODUCTION_REQUEST_VIEW);
    const canViewProductionBatches = useHasPermission(PERMISSIONS.PRODUCTION_BATCH_VIEW);
    const canViewMachines = useHasPermission(PERMISSIONS.MACHINE_MASTER_VIEW);
    const canViewPlants = useHasPermission(PERMISSIONS.PLANT_MASTER_VIEW);

    const canViewSalesOrders = useHasPermission(PERMISSIONS.SO_VIEW);
    const canCreateInHouseSO = useHasPermission(PERMISSIONS.SO_INHOUSE_CREATE);

    const canViewSettings = useHasPermission(PERMISSIONS.SETTINGS_VIEW);

    const canViewLabs = useHasPermission(PERMISSIONS.LABS_VIEW);
    const canViewCollectors = useHasPermission(PERMISSIONS.COLLECTORS_VIEW);
    const canViewTransporters = useHasPermission(PERMISSIONS.TRANSPORTER_VIEW);


    const isActiveCategory = (paths) => paths.some(path => location.pathname.startsWith(path));

    return (
        <>
            <GoogleTranslateManager selectors={noTranslateSelectors} />
            <nav className="navbar navbar-vertical navbar-expand-lg">
                <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
                    <div className="navbar-vertical-content">
                        <ul className="navbar-nav flex-column mt-3" id="navbarVerticalNav">

                            {/* Dashboard */}
                            <li className="nav-item">
                                <div className="nav-item-wrapper">

                                    {/* <Link className={`nav-link dropdown-indicator label-1 ${location.pathname === '/dashboard' ? 'active' : ''}`} to="/dashboard" role="button" data-bs-toggle="" aria-expanded="false">
                                        <div className="d-flex align-items-center">
                                            <span className="nav-link-icon">
                                                <FiPieChart />
                                            </span>
                                            <span className="nav-link-text-wrapper">
                                                <span className="nav-link-text">Dashboard</span>
                                            </span>
                                        </div>
                                    </Link> */}



                                    <Link
                                        className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/dashboard', '/sales-dashboard']) ? 'active' : ''}`}
                                        to="#dashboardd"
                                        role="button"
                                        data-bs-toggle="collapse"
                                        aria-expanded={isActiveCategory(['/dashboard', '/sales-dashboard'])}
                                        aria-controls="dashboardd"
                                    >
                                        <div className="d-flex align-items-center">
                                            <div className="dropdown-indicator-icon-wrapper">
                                                <FaCaretRight className="dropdown-indicator-icon" />
                                            </div>
                                            <span className="nav-link-icon">
                                                <FiPieChart />
                                            </span>
                                            <span className="nav-link-text">Dashboard</span>
                                        </div>
                                    </Link>
                                    <div className="parent-wrapper label-1">
                                        <ul
                                            className={`nav collapse parent ${isActiveCategory(['/dashboard', '/sales-dashboard']) ? 'show' : ''}`}
                                            data-bs-parent="#navbarVerticalCollapse"
                                            id="dashboardd"
                                        >
                                            <li className="nav-item">
                                                <Link className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`} to="/dashboard">
                                                    <span className="nav-link-text">Dashboard</span>
                                                </Link>
                                            </li>

                                            <li className="nav-item">
                                                <Link className={`nav-link ${location.pathname === '/sales-dashboard' ? 'active' : ''}`} to="/sales-dashboard">
                                                    <span className="nav-link-text">Sales Dashboard</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>

                            {/* Inventory Management - Show if user has any inventory permissions */}
                            {(canViewPackagingMaterial) && (
                                <li className="nav-item">
                                    <div className="nav-item-wrapper">
                                        <Link
                                            className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/products', '/warehouses', '/packaging-material', '/inventory', '/stock', '/packing-operations', 'stock-transfers']) ? 'active' : ''}`}
                                            to="#inventory"
                                            role="button"
                                            data-bs-toggle="collapse"
                                            aria-expanded={isActiveCategory(['/products', '/warehouses', '/packaging-material', '/inventory', '/stock', '/packing-operations', 'stock-transfers'])}
                                            aria-controls="inventory"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="dropdown-indicator-icon-wrapper">
                                                    <FaCaretRight className="dropdown-indicator-icon" />
                                                </div>
                                                <span className="nav-link-icon">
                                                    <FiPackage />
                                                </span>
                                                <span className="nav-link-text">Inventory</span>
                                            </div>
                                        </Link>
                                        <div className="parent-wrapper label-1">
                                            <ul
                                                className={`nav collapse parent ${isActiveCategory(['/products', '/warehouses', '/packaging-material', '/inventory', '/stock', '/packing-operations', '/stock-transfer']) ? 'show' : ''}`}
                                                data-bs-parent="#navbarVerticalCollapse"
                                                id="inventory"
                                            >
                                                <li className="nav-item">
                                                    {/* <Link className={`nav-link ${location.pathname === '/stock' ? 'active' : ''}`} to="/stock">
                                                        <span className="nav-link-text">Stock Overview</span>
                                                    </Link> */}
                                                </li>
                                                <li className="nav-item">
                                                    <Link className={`nav-link ${location.pathname === '/inventory' ? 'active' : ''}`} to="/inventory">
                                                        <span className="nav-link-text">Inventory</span>
                                                    </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className={`nav-link ${location.pathname.includes('/stock-transfer-instances') ? 'active' : ''}`} to="/stock-transfer-instances">
                                                        <span className="nav-link-text">Stock Transfers</span>
                                                    </Link>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <Link className={`nav-link ${location.pathname.includes('/stock-transfer') ? 'active' : ''}`} to="/stock-transfer">
                                                        <span className="nav-link-text">New Stock Transfers</span>
                                                    </Link>
                                                </li> */}
                                                {canViewPackagingMaterial && (
                                                    <>
                                                        {/* <li className="nav-item">
                                                            <Link className={`nav-link ${location.pathname === '/packing-operations' ? 'active' : ''}`} to="/packing-operations">
                                                                <span className="nav-link-text">Packing Operations</span>
                                                            </Link>
                                                        </li> */}
                                                        <li className="nav-item">
                                                            <Link className={`nav-link ${location.pathname === '/packing-operations' ? 'active' : ''}`} to="/packing-operations">
                                                                <span className="nav-link-text">Packing Operations</span>
                                                            </Link>
                                                        </li>
                                                    </>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            )}

                            {/* Procurement - Show if user has procurement permissions */}
                            {(canViewPurchaseRequests || canViewPurchaseOrders) && (
                                <li className="nav-item">
                                    <div className="nav-item-wrapper">
                                        <Link
                                            className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/purchase_requests', '/purchase-orders', '/rfqs']) ? 'active' : ''}`}
                                            to="#procurement"
                                            role="button"
                                            data-bs-toggle="collapse"
                                            aria-expanded={isActiveCategory(['/purchase_requests', '/purchase-orders', '/rfqs'])}
                                            aria-controls="procurement"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="dropdown-indicator-icon-wrapper">
                                                    <FaCaretRight className="dropdown-indicator-icon" />
                                                </div>
                                                <span className="nav-link-icon">
                                                    <FiShoppingCart />
                                                </span>
                                                <span className="nav-link-text">Procurement</span>
                                            </div>
                                        </Link>
                                        <div className="parent-wrapper label-1">
                                            <ul
                                                className={`nav collapse parent ${isActiveCategory(['/purchase_requests', '/purchase-orders', '/rfqs']) ? 'show' : ''}`}
                                                data-bs-parent="#navbarVerticalCollapse"
                                                id="procurement"
                                            >
                                                {canViewPurchaseRequests && (
                                                    <>
                                                        <li className="nav-item">
                                                            <Link className={`nav-link ${location.pathname === '/purchase_requests' ? 'active' : ''}`} to="/purchase_requests">
                                                                <span className="nav-link-text">Purchase Requests</span>
                                                            </Link>
                                                        </li>
                                                        <li className="nav-item">
                                                            <Link className={`nav-link ${location.pathname === '/rfqs' ? 'active' : ''}`} to="/rfqs">
                                                                <span className="nav-link-text">RFQs</span>
                                                            </Link>
                                                        </li>
                                                    </>
                                                )}
                                                {canViewPurchaseOrders && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/purchase-orders' ? 'active' : ''}`} to="/purchase-orders">
                                                            <span className="nav-link-text">Purchase Orders</span>
                                                        </Link>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            )}

                            {/* Production - Show if user has production permissions */}
                            {(canViewBOM || canViewProductionRequests || canViewProductionBatches || canViewMachines || canViewPlants) && (
                                <li className="nav-item">
                                    <div className="nav-item-wrapper">
                                        <Link
                                            className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/boms', '/batches', '/plants', '/production-requests', '/machines']) ? 'active' : ''}`}
                                            to="#production"
                                            role="button"
                                            data-bs-toggle="collapse"
                                            aria-expanded={isActiveCategory(['/boms', '/batches', '/plants', '/production-requests', '/machines'])}
                                            aria-controls="production"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="dropdown-indicator-icon-wrapper">
                                                    <FaCaretRight className="dropdown-indicator-icon" />
                                                </div>
                                                <span className="nav-link-icon">
                                                    <SiProgress />
                                                </span>
                                                <span className="nav-link-text">Production</span>
                                            </div>
                                        </Link>
                                        <div className="parent-wrapper label-1">
                                            <ul
                                                className={`nav collapse parent ${isActiveCategory(['/boms', '/batches', '/plants', '/production-requests', '/machines']) ? 'show' : ''}`}
                                                data-bs-parent="#navbarVerticalCollapse"
                                                id="production"
                                            >
                                                {canViewBOM && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/boms' ? 'active' : ''}`} to="/boms">
                                                            <span className="nav-link-text">Bill Of Material (BOM)</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewProductionRequests && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/production-requests' ? 'active' : ''}`} to="/production-requests">
                                                            <span className="nav-link-text">Production Requests</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewProductionBatches && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/batches' ? 'active' : ''}`} to="/batches">
                                                            <span className="nav-link-text">Production Batches</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewMachines && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/machines' ? 'active' : ''}`} to="/machines">
                                                            <span className="nav-link-text">Machines</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewPlants && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/plants' ? 'active' : ''}`} to="/plants">
                                                            <span className="nav-link-text">Plants</span>
                                                        </Link>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            )}

                            {/* Sales */}
                            {canViewSalesOrders && (
                                <li className="nav-item">
                                    <div className="nav-item-wrapper">
                                        <Link
                                            className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/sales-orders']) ? 'active' : ''}`}
                                            to="#sales"
                                            role="button"
                                            data-bs-toggle="collapse"
                                            aria-expanded={isActiveCategory(['/sales-orders'])}
                                            aria-controls="sales"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="dropdown-indicator-icon-wrapper">
                                                    <FaCaretRight className="dropdown-indicator-icon" />
                                                </div>
                                                <span className="nav-link-icon">
                                                    <FiTruck />
                                                </span>
                                                <span className="nav-link-text">Sales Orders</span>
                                            </div>
                                        </Link>
                                        <div className="parent-wrapper label-1">
                                            <ul
                                                className={`nav collapse parent ${isActiveCategory(['/sales-orders']) ? 'show' : ''}`}
                                                data-bs-parent="#navbarVerticalCollapse"
                                                id="sales"
                                            >
                                                <li className="nav-item">
                                                    <Link className={`nav-link ${location.pathname === '/sales-orders' ? 'active' : ''}`} to="/sales-orders">
                                                        <span className="nav-link-text">All Sales Orders</span>
                                                    </Link>
                                                </li>
                                                {canCreateInHouseSO && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/sales-orders/create-in-house' ? 'active' : ''}`} to="/sales-orders/create-in-house">
                                                            <span className="nav-link-text">Create In-House SO</span>
                                                        </Link>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            )}

                            {/* Reports */}
                            <li className="nav-item">
                                <div className="nav-item-wrapper">
                                    <Link
                                        className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/reports', '/reporting-dashboard']) ? 'active' : ''}`}
                                        to="#reports"
                                        role="button"
                                        data-bs-toggle="collapse"
                                        aria-expanded={isActiveCategory(['/reports', '/reporting-dashboard'])}
                                        aria-controls="reports"
                                    >
                                        <div className="d-flex align-items-center">
                                            <div className="dropdown-indicator-icon-wrapper">
                                                <FaCaretRight className="dropdown-indicator-icon" />
                                            </div>
                                            <span className="nav-link-icon">
                                                <FiBarChart />
                                            </span>
                                            <span className="nav-link-text">Reports</span>
                                        </div>
                                    </Link>
                                    <div className="parent-wrapper label-1">
                                        <ul
                                            className={`nav collapse parent ${isActiveCategory(['/reports', '/reporting-dashboard']) ? 'show' : ''}`}
                                            data-bs-parent="#navbarVerticalCollapse"
                                            id="reports"
                                        >
                                            {/* <li className="nav-item">
                                                <Link className={`nav-link ${location.pathname === '/reporting-dashboard' ? 'active' : ''}`} to="/reporting-dashboard">
                                                    <span className="nav-link-text">Analytics Dashboard</span>
                                                </Link>
                                            </li> */}
                                            <li className="nav-item">
                                                <Link className={`nav-link ${location.pathname === '/reports' ? 'active' : ''}`} to="/reports">
                                                    <span className="nav-link-text">Custom Reports</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>

                            {/* Settings */}
                            {canViewSettings && (
                                <li className="nav-item">
                                    <div className="nav-item-wrapper">
                                        <Link
                                            className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/settings/company', '/stock/add-existing']) ? 'active' : ''}`}
                                            to="#settings"
                                            role="button"
                                            data-bs-toggle="collapse"
                                            aria-expanded={isActiveCategory(['/settings/company', '/stock/add-existing'])}
                                            aria-controls="settings"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="dropdown-indicator-icon-wrapper">
                                                    <FaCaretRight className="dropdown-indicator-icon" />
                                                </div>
                                                <span className="nav-link-icon">
                                                    <FiSettings />
                                                </span>
                                                <span className="nav-link-text">Settings</span>
                                            </div>
                                        </Link>
                                        <div className="parent-wrapper label-1">
                                            <ul
                                                className={`nav collapse parent ${isActiveCategory(['/settings/company', '/stock/add-existing']) ? 'show' : ''}`}
                                                data-bs-parent="#navbarVerticalCollapse"
                                                id="settings"
                                            >
                                                <li className="nav-item">
                                                    <Link className={`nav-link ${location.pathname === '/settings/company' ? 'active' : ''}`} to="/settings/company">
                                                        <span className="nav-link-text">Company Settings</span>
                                                    </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className={`nav-link ${location.pathname === '/stock/add-existing' ? 'active' : ''}`} to="/stock/add-existing">
                                                        <span className="nav-link-text">Add Existing Stock</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            )}

                            {(canManageUsers || canViewBOM || canViewVendors || canViewBuyers || canManageStaff) && (
                                <li className="nav-item">
                                    <div className="nav-item-wrapper">
                                        <Link
                                            className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/brokers', '/vendors', '/buyers', '/staff', '/labs', '/collectors']) ? 'active' : ''}`}
                                            to="#users"
                                            role="button"
                                            data-bs-toggle="collapse"
                                            aria-expanded={isActiveCategory(['/brokers', '/vendors', '/buyers', '/staff', '/labs', '/collectors'])}
                                            aria-controls="users"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="dropdown-indicator-icon-wrapper">
                                                    <FaCaretRight className="dropdown-indicator-icon" />
                                                </div>
                                                <span className="nav-link-icon">
                                                    <FiUsers />
                                                </span>
                                                <span className="nav-link-text">User Management</span>
                                            </div>
                                        </Link>
                                        <div className="parent-wrapper label-1">
                                            <ul
                                                className={`nav collapse parent ${isActiveCategory(['/brokers', '/vendors', '/buyers', '/staff', '/labs', '/collectors']) ? 'show' : ''}`}
                                                data-bs-parent="#navbarVerticalCollapse"
                                                id="users"
                                            >
                                                {canViewBrokers && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/brokers' ? 'active' : ''}`} to="/brokers">
                                                            <span className="nav-link-text">Brokers</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewVendors && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/vendors' ? 'active' : ''}`} to="/vendors">
                                                            <span className="nav-link-text">Vendors</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewBuyers && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/buyers' ? 'active' : ''}`} to="/buyers">
                                                            <span className="nav-link-text">Buyers</span>
                                                        </Link>
                                                    </li>
                                                )}

                                                {canManageStaff && (
                                                    <>
                                                        <li className="nav-item">
                                                            <Link className={`nav-link ${location.pathname === '/staff' ? 'active' : ''}`} to="/staff">
                                                                <span className="nav-link-text">All Staff</span>
                                                            </Link>
                                                        </li>
                                                        <li className="nav-item">
                                                            <Link className={`nav-link ${location.pathname === '/staff/roles' ? 'active' : ''}`} to="/staff/roles">
                                                                <span className="nav-link-text">Staff Roles</span>
                                                            </Link>
                                                        </li>
                                                    </>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            )}

                            {/* Masters */}
                            {(canViewTransporters || canViewCollectors || canViewLabs || canViewPackagingMaterial || canViewWarehouses || canViewProducts) && (
                                <li className="nav-item">
                                    <div className="nav-item-wrapper">
                                        <Link
                                            className={`nav-link dropdown-indicator label-1 ${isActiveCategory(['/transporters', '/warehouses', '/packaging-material', '/collectors', '/labs', '/products']) ? 'active' : ''}`}
                                            to="#masters"
                                            role="button"
                                            data-bs-toggle="collapse"
                                            aria-expanded={isActiveCategory(['/transporters', '/warehouses', '/packaging-material', '/collectors', '/labs', '/products'])}
                                            aria-controls="masters"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="dropdown-indicator-icon-wrapper">
                                                    <FaCaretRight className="dropdown-indicator-icon" />
                                                </div>
                                                <span className="nav-link-icon">
                                                    <FiLayout />
                                                </span>
                                                <span className="nav-link-text">Masters</span>
                                            </div>
                                        </Link>
                                        <div className="parent-wrapper label-1">
                                            <ul
                                                className={`nav collapse parent ${isActiveCategory(['/transporters', '/warehouses', '/packaging-material', '/collectors', '/labs', '/products']) ? 'show' : ''}`}
                                                data-bs-parent="#navbarVerticalCollapse"
                                                id="masters"
                                            >
                                                {canViewProducts && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/products' ? 'active' : ''}`} to="/products">
                                                            <span className="nav-link-text">Products</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewWarehouses && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/warehouses' ? 'active' : ''}`} to="/warehouses">
                                                            <span className="nav-link-text">Warehouses</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewPackagingMaterial && (
                                                    <>
                                                        <li className="nav-item">
                                                            <Link className={`nav-link ${location.pathname === '/packaging-material' ? 'active' : ''}`} to="/packaging-material">
                                                                <span className="nav-link-text">Packaging Material</span>
                                                            </Link>
                                                        </li>
                                                    </>
                                                )}
                                                {canViewTransporters && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/transporters' ? 'active' : ''}`} to="/transporters">
                                                            <span className="nav-link-text">Transporters</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewLabs && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/labs' ? 'active' : ''}`} to="/labs">
                                                            <span className="nav-link-text">Labs</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {canViewCollectors && (
                                                    <li className="nav-item">
                                                        <Link className={`nav-link ${location.pathname === '/collectors' ? 'active' : ''}`} to="/collectors">
                                                            <span className="nav-link-text">Collectors</span>
                                                        </Link>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            )}

                        </ul>
                    </div>
                </div>
                <div className="navbar-vertical-footer">
                    <button 
                        className="btn navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
                        onClick={handleNavbarVerticalToggle}
                    >
                        <span className="uil uil-left-arrow-to-left fs-8" />
                        <span className="uil uil-arrow-from-right fs-8" />
                        <span className="navbar-vertical-footer-text ms-2">Collapsed View</span>
                    </button>
                </div>
            </nav>
            <nav className="navbar navbar-top fixed-top navbar-expand" id="navbarDefault">
                <div className="collapse navbar-collapse justify-content-between">
                    <div className="navbar-logo">
                        <button
                            className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarVerticalCollapse"
                            aria-controls="navbarVerticalCollapse"
                            aria-expanded="false"
                            aria-label="Toggle Navigation"
                        >
                            <span className="navbar-toggle-icon">
                                <span className="toggle-line" />
                            </span>
                        </button>
                        <Link className="navbar-brand me-1 me-sm-3" to="/" />
                        <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center">
                                <img
                                    src="/assets/img/icons/logo.png"
                                    alt="fms-logo"
                                    width={27}
                                />
                                <h5 className="logo-text ms-2 d-none d-sm-block">FMS</h5>
                            </div>
                        </div>
                    </div>
                    {/* <div
                        className="search-box navbar-top-search-box d-none d-lg-block"
                        data-list='{"valueNames":["title"]}'
                        style={{ maxWidth: "25rem" }}
                    >
                        <form
                            className="position-relative"
                            data-bs-toggle="search"
                            data-bs-display="static"
                        >
                            <input
                                className="form-control search-input fuzzy-search rounded-pill form-control-sm"
                                type="search"
                                placeholder="Search..."
                                aria-label="Search"
                            />
                            <span className="fas fa-search search-box-icon" />
                        </form>
                        <div
                            className="btn-close position-absolute end-0 top-50 translate-middle cursor-pointer shadow-none"
                            data-bs-dismiss="search"
                        >
                            <button className="btn btn-link p-0" aria-label="Close" />
                        </div>
                        <div className="dropdown-menu border start-0 py-0 overflow-hidden w-100">
                            <div className="scrollbar-overlay" style={{ maxHeight: "30rem" }}>
                                <div className="list pb-3">
                                    <hr className="my-0" />
                                    <h6 className="dropdown-header text-body-highlight fs-9 border-bottom border-translucent py-2 lh-sm">
                                        Related Searches
                                    </h6>
                                    <div className="py-2">
                                        <Link
                                            className="dropdown-item"
                                            to="apps/e-commerce/landing/product-details.html"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="fw-normal text-body-highlight title">
                                                    <span
                                                        className="fa-brands fa-firefox-browser text-body"
                                                        data-fa-transform="shrink-2"
                                                    />{" "}
                                                    Search in the Web MacBook
                                                </div>
                                            </div>
                                        </Link>
                                        <Link
                                            className="dropdown-item"
                                            to="apps/e-commerce/landing/product-details.html"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="fw-normal text-body-highlight title">
                                                    {" "}
                                                    <span
                                                        className="fa-brands fa-chrome text-body"
                                                        data-fa-transform="shrink-2"
                                                    />
                                                    Store MacBook″
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <p className="fallback fw-bold fs-7 d-none">No Result Found.</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <ul className="navbar-nav navbar-nav-icons flex-row">
                        <li className="nav-item d-flex align-items-center me-2">
                            <div id="google_translate_element"></div>
                        </li>
                        <li className="nav-item d-lg-none">
                            <Link
                                className="nav-link"
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#searchBoxModal"
                            >
                                <span className="d-block" style={{ height: 20, width: 20 }}>
                                    <FiSearch style={{ height: 19, width: 19, marginBottom: 2 }} />
                                </span>
                            </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link
                                className="nav-link position-relative"
                                to="#"
                                style={{ minWidth: "2.25rem" }}
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                data-bs-auto-close="outside"
                            >
                                <span className="d-block" style={{ height: 20, width: 20 }}>
                                    <FiBell style={{ height: 20, width: 20 }} />
                                </span>
                                {unreadCount > 0 && (
                                    <span className="badge bg-danger position-absolute top-0 start-100 translate-middle p-1">
                                        <span className="visually-hidden">unread notifications</span>
                                    </span>
                                )}
                            </Link>
                            <div
                                className="dropdown-menu dropdown-menu-end notification-dropdown-menu py-0 shadow border navbar-dropdown-caret"
                                id="navbarDropdownNotfication"
                                aria-labelledby="navbarDropdownNotfication"
                            >
                                <div className="card position-relative border-0">
                                    <div className="card-header p-2">
                                        <div className="d-flex justify-content-between">
                                            <h5 className="text-body-emphasis mb-0">Notifications</h5>
                                            <button
                                                className="btn btn-link p-0 fs-9 fw-normal"
                                                type="button"
                                                onClick={markAllAsRead}
                                            >
                                                Mark all as read
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="scrollbar-overlay" style={{ height: "27rem" }}>
                                            {notifications.length === 0 ? (
                                                <div className="text-center py-4">
                                                    <p className="text-muted mb-0">No notifications</p>
                                                </div>
                                            ) : (
                                                notifications.slice(0, 10).map((notification) => (
                                                    <div
                                                        key={notification.id}
                                                        className={`notification-item border-bottom border-translucent p-3 ${!notification.read ? 'bg-light' : ''}`}
                                                        onClick={() => markAsRead(notification.id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <div className="d-flex align-items-start">
                                                            <div className={`notification-icon me-3 ${notification.type === 'danger' ? 'text-danger' : notification.type === 'warning' ? 'text-warning' : 'text-info'}`}>
                                                                <i className={`fas ${notification.type === 'danger' ? 'fa-exclamation-triangle' : notification.type === 'warning' ? 'fa-exclamation-circle' : 'fa-info-circle'}`}></i>
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <h6 className="notification-title mb-1 fs-9 fw-semibold">
                                                                    {notification.title}
                                                                </h6>
                                                                <p className="notification-message mb-1 fs-10 text-body-secondary">
                                                                    {notification.message}
                                                                </p>
                                                                <small className="notification-time text-body-tertiary">
                                                                    {new Date(notification.timestamp).toLocaleString()}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                    <div className="card-footer p-0 border-top border-translucent border-0">
                                        <div className="my-2 text-center fw-bold fs-10 text-body-tertiary text-opactity-85">
                                            <Link className="fw-bolder" to="/notifications">
                                                View all notifications
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li className="nav-item dropdown">
                            <Link
                                className="nav-link lh-1 pe-0"
                                id="navbarDropdownUser"
                                to="#!"
                                role="button"
                                data-bs-toggle="dropdown"
                                data-bs-auto-close="outside"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <div className="avatar avatar-l ">
                                    <img
                                        className="rounded-circle "
                                        src="/assets/img/team/male.jpg"
                                        alt=""
                                        width={40}
                                    />
                                </div>
                            </Link>
                            <div
                                className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border"
                                aria-labelledby="navbarDropdownUser"
                            >
                                <div className="card position-relative border-0">
                                    <div className="card-body p-0">
                                        <div className="text-center pt-4 pb-3">
                                            <div className="avatar avatar-xl ">
                                                <img
                                                    className="rounded-circle "
                                                    src="/assets/img/team/male.jpg"
                                                    alt=""
                                                    width={72}
                                                />
                                            </div>
                                            <h6 id="profile-user-name" className="mt-2 text-body-emphasis">{loggedUser?.name}</h6>
                                        </div>
                                    </div>
                                    {canViewSettings && (
                                        <div
                                            className="overflow-auto scrollbar"
                                            style={{ height: "2.5rem" }}
                                        >
                                            <ul className="nav d-flex flex-column mb-2 pb-1">
                                                {/* <li className="nav-item">
                                                <Link className="nav-link px-3 d-block" to="#!">
                                                    {" "}
                                                    <FiUser
                                                        className="me-2 text-body align-bottom"
                                                    />
                                                    <span>Profile</span>
                                                </Link>
                                            </li> */}
                                                <li className="nav-item">
                                                    <Link className="nav-link px-3 d-block" to="/settings/company">
                                                        {" "}
                                                        <FiSettings
                                                            className="me-2 text-body align-bottom"
                                                        />
                                                        Settings{" "}
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                    <div className="card-footer p-0 border-top border-translucent">
                                        {/* <ul className="nav d-flex flex-column my-3">
                                            <li className="nav-item">
                                            </li>
                                        </ul>
                                        <hr /> */}
                                        <div className="px-3">
                                            {" "}
                                            <Link to="/logout" className="btn btn-phoenix-secondary d-flex flex-center w-100">
                                                <FiLogOut className="me-2" />
                                                Sign out
                                            </Link>
                                        </div>
                                        <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
                                            <Link className="text-body-quaternary me-1" to="#!">
                                                Privacy policy
                                            </Link>
                                            •
                                            <Link className="text-body-quaternary mx-1" to="#!">
                                                Terms
                                            </Link>
                                            •
                                            <Link className="text-body-quaternary ms-1" to="#!">
                                                Cookies
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    );
};

export default Header;
